import React from 'react';
// components
import CommonButton, { CommonButtonProps } from './CommonButton';
import { SwapHorizOutlinedIcon } from 'components/Icons';

type Props =
  Omit<CommonButtonProps, 'icon' | 'label' | 'type'>
  & {
    label?: CommonButtonProps['label'];
    type?: CommonButtonProps['type'];
  };

export const SwapButton = (props: Props): JSX.Element => {
  const label = props.label !== undefined ? props.label : 'Swap';
  const type = props.type !== undefined ? props.type : 'icon';
  return (
    <CommonButton
      { ...props }
      type={ type }
      label={ label }
      icon={ type === 'text' ? undefined : <SwapHorizOutlinedIcon /> }
    />
  );
};

export default SwapButton;
